import ButtonSort from '../../../../shared/ButtonSort';

const Header = ({
  isEliminator,
  headerCheckboxRef,
  allSelected,
  toggleAllFiltered,
  sortConfig,
  handleSort,
  stickyOffset,
}) => {
  return (
    <thead className="bg-gray-50 sticky z-10" style={{ top: stickyOffset + 12 }}>
      <tr>
        {isEliminator && (
          <th className="w-[5%] py-3">
            <div className="inline-flex items-center justify-center">
              <input
                type="checkbox"
                className="h-4 w-4 accent-personalized"
                ref={headerCheckboxRef}
                checked={allSelected}
                onChange={toggleAllFiltered}
              />
            </div>
          </th>
        )}
        <th className={`${isEliminator ? 'w-[20%]' : 'w-[25%]'} py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider`}>
          <div className={`inline-flex items-center ${!isEliminator ? 'px-6' : ''}`}>
            Nombre
            <ButtonSort handleSort={handleSort} field="Name" direction={sortConfig.direction} />
          </div>
        </th>
        <th className="w-[25%] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          <div className="inline-flex items-center">
            Email principal
            <ButtonSort handleSort={handleSort} field="PrincipalEmail" direction={sortConfig.direction} />
          </div>
        </th>
        <th className="w-[20%] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          <div className="inline-flex items-center">
            Email alternativo
            <ButtonSort handleSort={handleSort} field="AlternativeEmail" direction={sortConfig.direction} />
          </div>
        </th>
        <th className="w-[10%] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          <div className="inline-flex items-center">
            Puntos
            <ButtonSort handleSort={handleSort} field="Score" direction={sortConfig.direction} />
          </div>
        </th>
        <th className="w-[10%] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          <div className="inline-flex items-center">
            Nivel
            <ButtonSort handleSort={handleSort} field="Level" direction={sortConfig.direction} />
          </div>
        </th>
        <th className="w-[10%] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Acciones
        </th>
      </tr>
    </thead>
  );
};

export default Header;
